var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCrypto = function SvgCrypto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 26",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.659 10.425c0-.463-.309-.771-.772-.771h-3.086c-.463 0-.771.308-.771.771v10.801h4.629v-10.8Zm6.557 1.543c0-.463-.308-.771-.771-.771h-3.086c-.463 0-.772.308-.772.771v9.258h4.63v-9.258Zm3.086 11.187H1.157c-.617 0-1.157.54-1.157 1.157 0 .618.54 1.158 1.157 1.158h23.145c.618 0 1.158-.54 1.158-1.158 0-.617-.54-1.157-1.158-1.157ZM8.101 14.283c0-.463-.309-.772-.772-.772H4.243c-.463 0-.771.309-.771.772v6.943H8.1v-6.943ZM22.374.01l-3.472.463c-.54.077-.771.771-.386 1.157l.772.772-2.777 2.777-4.63-3.472a1.276 1.276 0 0 0-1.465 0l-7.33 6.095c-.463.386-.54 1.157-.154 1.62.232.309.54.386.926.386.231 0 .54-.077.771-.231l6.635-5.478 4.707 3.549c.462.386 1.08.308 1.543-.077l3.548-3.55.386.618c.386.386 1.08.154 1.157-.386l.54-3.472c0-.463-.385-.848-.771-.771Z"
  })));
};

export default SvgCrypto;